import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import store from "./stores";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toastify.css";
import Web from "./routes/Web";
import { initializeTheme } from "./stores/slices/Theme";
import { WebSocketProvider } from "./contexts/WebSocketContext";

// Initialize theme on app start
store.dispatch(initializeTheme());

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <WebSocketProvider>
        <ToastContainer />
        <Web />
      </WebSocketProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
